import { css } from '@emotion/react';

import { breakpoints, typography } from '~/src/styles';

export const stylesVariables = css({
  '--Mobile-Horizontal-Padding': '28px',
  '--Tablet-Horizontal-Padding': '68px',
  '--Desktop-Horizontal-Padding': '0px',
  '--Max-Desktop-Width': 'min(1200px,100% - 2 * var(--Tablet-Horizontal-Padding))',
});

const contentPadding = css({
  paddingLeft: 'var(--Mobile-Horizontal-Padding)',
  paddingRight: 'var(--Mobile-Horizontal-Padding)',
  [breakpoints.minTablet]: {
    paddingLeft: 'var(--Tablet-Horizontal-Padding)',
    paddingRight: 'var(--Tablet-Horizontal-Padding)',
  },
  [breakpoints.minDesktop]: {
    paddingLeft: 'var(--Desktop-Horizontal-Padding)',
    paddingRight: 'var(--Desktop-Horizontal-Padding)',
  },
});

export const commonStyles = {
  contentPadding,
  containerMaxWidth: css({
    [breakpoints.minDesktop]: {
      maxWidth: `var(--Max-Desktop-Width)`,
    },
  }),
  carouselContainerStyles: css({
    width: '100vw',
    zIndex: 10,
    paddingRight: 0,
    [breakpoints.minDesktop]: {
      width: '100%',
    },
  }),
  h1: css(contentPadding, typography.heading1, {
    color: 'var(--Dark-Text, #27292D)',
  }),
};
